import { Component, OnInit } from "@angular/core";
 
import Swal from "sweetalert2";
import { first } from "rxjs/operators";
import { AlertService, CandidateJobsService } from 'src/app/shared';
import { Router } from '@angular/router';
import { TestbatchService } from "src/app/shared/services/test-batch/testbatch.service";

@Component({
  selector: "app-jobs",
  templateUrl: "./jobs.component.html",
  styleUrls: ["./jobs.component.scss"]
})
export class JobsComponent implements OnInit {

  sender = "install-comp";
  filter = {
    key: ''
  };
  actions: any = [];
  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  actionCount = 0;
  /** end pagination */
  actionOptions:any  = [];
  batches: any = [];
  selectedBatch: string = '';

  constructor(private actionService: CandidateJobsService,
    private alertService: AlertService,
    private testbatchService: TestbatchService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getAllActionOptions ();
    this.loadAll();
    this.searchActions();
    this.getAllBatches()
  }


  getAllActionOptions (){
    this.actionService.getAllActionOptions()
    .subscribe(res => {
      this.actionOptions = res || [];
    });
  }

  getAllBatches () {
    this.testbatchService
        .getAll()
        .pipe(first())
        .subscribe(res => {
          this.batches = res;
        });
  }


  loadAll() {

    this.actionService.getActions(this.filter)
      .subscribe(res => {
        this.actions = res;
      });
  } 
  

  onCancel(action) {

    this.actionService.cancelAction(action._id)
      .subscribe(res => {
        this.loadAll();
      });
  }

  getLogs(id) {
    var url = 'manager/jobs/' + id + '/logs';
    this.router.navigate([url]);
  }

  

  onActionOption (opt){
    Swal.fire({
      title: 'Are you sure?',
      text: opt.msg,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, do it',
      cancelButtonText: 'No, will do later'
    }).then((result) => {

      if (opt.code === 'QUESTION_BANK_PUSH') {
        if (!this.selectedBatch) {
          this.alertService.err(this.sender, "Please select batch before 'Question back push'");
            return;
        }
      }

      if (result.value) {
        this.actionService.addAction({name: opt.code, selectedBatch: this.selectedBatch})
        .subscribe(res => {
          if (res["status"] == "error") {
            this.alertService.err(this.sender, res["message"]);
            return;
          }
  
          this.alertService.show(this.sender, res["message"] || "success");
          this.loadAll();
  
        });
      }

    });
  }

  searchActions() {
    this.actionService
      .searchActions(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.actionCount = res["count"];
        this.actions = res["data"];
      });
  }

  fetchActionData(e) {
    this.currentPage = e;
    this.searchActions();
  }
}
